<template>
  <div class="h-100 my-5">
    <b-button
      type="submit"
      class="myButton"
      @click="$router.go(-1)">
      {{ $t('common.Cancel') }}
    </b-button>
    <div class="dp02 p-3 mt-3">
      <div class="text-center col-lg-12">
        <h2>{{ $t('EditRole.EditRole') }} {{ roleName }}</h2>
        <p>{{ $t('EditRole.SubTitle') }}</p>
      </div>
      <div class="row">
        <div class="col-8 offset-2 mt-1 text-center">
          <div class="row">
            <div class="col-lg-6 text-center">
              <h3>{{ $t('EditRole.AvailablePermissions') }}</h3>
              <div class="dp04">
                <draggable group="permissions"
                           v-model="otherPermissions"
                           class="draggableWindow"
                           @start="adding = true"
                           @end="adding = false"
                           :class="removing ? 'windowRemoving' : ''">
                  <div v-for="element in otherPermissions"
                       :key="element.value"
                       class="dp04 list-group-item  draggableItem">
                    <font-awesome-icon icon="grip-horizontal"
                                       class="float-left" />
                    {{ element.displayName }}
                  </div>
                </draggable>
              </div>
            </div>
            <div class="col-lg-6 text-center">
              <h3>{{ $t('EditRole.AssignedPermissions') }}</h3>
              <div class="dp04">
                <draggable group="permissions"
                           v-model="rolePermissions"
                           class="draggableWindow"
                           @start="removing = true"
                           @end="removing = false"
                           :class="adding ? 'windowAdding' : ''">
                  <div v-for="element in rolePermissions"
                       :key="element.value"
                       class="dp04 list-group-item draggableItem">
                    <font-awesome-icon icon="grip-horizontal"
                                       class="float-left" />
                    {{ element.displayName }}
                  </div>
                </draggable>
              </div>
            </div>
          </div>
          <b-btn
            class="mt-3"
            variant="success"
            @click="saved();$router.go(-1)">
            {{ $t('common.Save') }}
          </b-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import draggable from 'vuedraggable';

export default {
  name: 'EditRole',
  components: {
    draggable
  },
  data() {
    return {
      removing: false,
      adding: false
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    '$i18n.locale': function () {
      this.fetchPermissions();
      this.fetchRole();
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapState('editRole', ['roleName']),
    rolePermissions: {
      get() {
        return this.$store.state.editRole.rolePermissions;
      },
      set(value) {
        const curr = this.$store.state.editRole.rolePermissions;
        this.setRolePermissions(value);
        if (value.length > curr.length) {
          const newPermission = value.filter((x) => !curr.map((y) => y.value).includes(x.value));
          this.addPermission(newPermission[0]).then(() => {
            this.$root.$bvToast.toast(this.$t('EditRole.SuccessAddingToast.Body'), {
              title: this.$t('EditRole.SuccessAddingToast.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
          }).catch(() => {
            this.setRolePermissions(curr);
            this.$root.$bvToast.toast(this.$t('EditRole.FailAddingToast.Body'), {
              title: this.$t('EditRole.FailAddingToast.Title'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
          });
        } else {
          const removedPermission = curr.filter((x) => !value.map((y) => y.value).includes(x.value));
          this.removePermission(removedPermission[0]).then(() => {
            this.$root.$bvToast.toast(this.$t('EditRole.SuccessRemoveToast.Body'), {
              title: this.$t('EditRole.SuccessRemoveToast.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
          }).catch(() => {
            this.setRolePermissions(curr);
            this.$root.$bvToast.toast(this.$t('EditRole.FailRemoveToast.Body'), {
              title: this.$t('EditRole.FailRemoveToast.Title'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
          });
        }
      }
    },
    otherPermissions: {
      get() {
        return this.$store.state.editRole.allPermissions
          .filter((x) => !this.$store.state.editRole.rolePermissions.map((y) => y.value).includes(x.value));
      },
      set() {

      }
    }
  },
  created() {
    this.resetContext();
    this.setRoleId(Number(this.id));
    this.fetchPermissions();
    this.fetchRole();
  },
  methods: {
    ...mapMutations({
      setRoleId: 'editRole/setRoleId',
      setRolePermissions: 'editRole/setRolePermissions'
    }),
    ...mapGetters({
      getOtherPermissions: 'editRole/getOtherPermissions'
    }),
    ...mapActions({ resetContext: 'editRole/resetContext',
      fetchRole: 'editRole/fetchRole',
      fetchPermissions: 'editRole/fetchPermissions',
      addPermission: 'editRole/addPermission',
      removePermission: 'editRole/removePermission' }),
    saved() {
      this.$root.$bvToast.toast(this.$t('EditRole.SaveToast.Body'), {
        title: this.$t('EditRole.SaveToast.Title'),
        variant: 'success',
        toaster: 'b-toaster-top-right'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.draggableWindow {
  min-height:300px;
  max-height:300px;
  overflow-y: scroll;
}

.draggableItem {
  cursor:move;
  cursor:grab;
}

.draggableItem:active {
  cursor:grabbing;
}

.draggableItem:hover {
  background-color: rgba(255, 255, 255, 0.11);
}

.windowRemoving {
  background-color: rgba(216, 86, 86, 0.4);
  transition: 0.6s all;
}

.windowAdding {
  background-color: rgba(37, 128, 37, 0.705);
  transition: 0.6s all;
}
</style>
